import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PAGE_TITLE } from "../../constants";
import { allRoutes } from "../routes.config";

const defaultTitle = import.meta.env.VITE_SITE_TITLE || "";
const envPrefix = import.meta.env.VITE_ENVIRONMENT !== "PRD" ? `**${import.meta.env.VITE_ENVIRONMENT}** - ` : "";

const createPageTitle = (page: string) => {
  return `${envPrefix}${PAGE_TITLE} - ${page}`;
};

export const TitleGuard = () => {
  const location = useLocation();

  useEffect(() => {
    if (document) {
      const route = allRoutes.find((item) => item.path === location.pathname);
      document.title = route?.name ? createPageTitle(route.name) : defaultTitle;
    }
  }, [location.pathname]);

  return <></>;
};
